export default function onUpdatePhotos(photos, newPhotosPerSubission, submissionId) {
  return photos.map(photo => {
    if (photo.submissionId === submissionId) {
      return { ...photo, photosPerSubmission: newPhotosPerSubission };
    }
    return photo;
  });
}
